import {FACEBOOK_CHANNEL} from '../components/channels/channels';

/**
 * Cómo se llama el nivel de grupo de anuncios en cada plataforma: en Meta es el «conjunto de
 * anuncios» (ad set); en Google, TikTok, LinkedIn y DV360, el «grupo de anuncios». Un canal que no
 * se conoce cae en «grupo», que es el nombre genérico.
 *
 * El backend manda el `channel` y nunca el rótulo (contrato de la tanda «Cruce paid media ↔ GA4»,
 * § 0): una sola tabla, acá, para la tarjeta de la agencia, la cuenta del cliente, la línea y los
 * tooltips del Tablero.
 *
 * El plural lo elige i18next por `count` (las claves son `_one` / `_other`), así que se pasa siempre
 * `count`, aunque sea 1.
 */
export function adgroupLevelLabel(t, channel, {count = 1} = {}) {
    const key = channel === FACEBOOK_CHANNEL ? 'channel_levels.adgroup_meta' : 'channel_levels.adgroup';
    return t(key, {count});
}

/** «anuncio» / «anuncios»: se llama igual en todas las plataformas. */
export function adLevelLabel(t, {count = 1} = {}) {
    return t('channel_levels.ad', {count});
}
